import React from "react";
import svgUrl from "/opt/actions-runner/_work/v3-swap/v3-swap/src/assets/svg/tooltip_triangle.svg?url";
const SvgTooltipTriangle = (props) => /* @__PURE__ */ React.createElement("svg", {
  width: 12,
  height: 7,
  viewBox: "0 0 12 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /* @__PURE__ */ React.createElement("path", {
  d: "M4.4 1.13333C5.2 0.0666671 6.8 0.0666668 7.6 1.13333L12 7H0L4.4 1.13333Z",
  fill: "#0D0E0E"
}));
export {SvgTooltipTriangle as ReactComponent};
export default svgUrl;
